
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/webhooks/webhook-events",
      function () {
        return require("private-next-pages/docs/api/webhooks/webhook-events.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/webhooks/webhook-events"])
      });
    }
  